export default "/images/framework/BattleAgainCht.cb5479d8.svg?cb5479d8";